<template>
  <div class="f-left w-100pct">
     <div class="my-title pd-hrzt-30px">
      Contributing
    </div>
    <div class="f-left w-100pct pd-hrzt-30px">
      <div class="markdown">
        1. Fork this repository.<br>
        2. Create new branch with feature name.<br>
        3. Run <b>npm install</b> and <b>npm run dev</b>.<br>
        4. Create your feature.<br>
        5. Commit and set commit message with feature name.<br>
        6. Push your code to your fork repository.<br>
        7. Create pull request. 🙂
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contributing'
}
</script>



// WEBPACK FOOTER //
// src/components/contributing/index.vue